import { render, staticRenderFns } from "./QrtlyAccountStatementLegacy.vue?vue&type=template&id=04a3c8aa&scoped=true&"
import script from "./QrtlyAccountStatementLegacy.vue?vue&type=script&lang=js&"
export * from "./QrtlyAccountStatementLegacy.vue?vue&type=script&lang=js&"
import style0 from "./QrtlyAccountStatementLegacy.vue?vue&type=style&index=0&id=04a3c8aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3c8aa",
  null
  
)

export default component.exports